import React from "react";

export default function MaintenanceView() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4">
      <section className="w-full max-w-2xl rounded-2xl border border-border bg-card p-8 text-center shadow-xl sm:p-12">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full bg-statusWarningBg px-3 py-1 text-xs font-semibold uppercase tracking-wider text-statusWarning">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-statusWarning opacity-75 motion-reduce:animate-none" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-statusWarning" />
          </span>
          Aviso
        </span>

        <h1 className="text-2xl font-bold tracking-tight text-foreground sm:text-3xl">
          Comunicado importante
        </h1>
        <div className="mt-6 space-y-4 text-left text-base leading-relaxed text-muted-foreground">
          <p>
            A Juri Ativos Judiciais informa que, em razão das alterações estabelecidas pela Resolução CMN nº 5.343/2026, do Banco Central, que trouxe novas regras para operações envolvendo créditos judiciais, as propostas de antecipação de créditos estão temporariamente suspensas.
          </p>
          <p>
            Para dar continuidade às operações, estamos constituindo um novo veículo de investimento, em conformidade com tais regulamentações.
          </p>
          <p>
            A Juri Ativos Judiciais continuará oferecendo novas propostas de antecipação de créditos aos trabalhadores e trabalhadoras, tanto em ações coletivas quanto em processos individuais, inclusive em demandas de interesse da categoria representada pelo sindicato que ainda não foram objetos de negociação, caso seja do interesse das partes envolvidas.
          </p>
          <p>
            Estamos apenas adaptando nossa estrutura às novas exigências e, nas próximas semanas, retomaremos nossos serviços normalmente.
          </p>
          <p>
            Reafirmando nosso compromisso com os trabalhadores e trabalhadoras, informamos que os valores das propostas serão mantidos integralmente e que, até 31/10/2026, comunicaremos as novas previsões de pagamento.
          </p>
          <p>
            Agradecemos a compreensão e permanecemos à disposição para esclarecimentos por meio do nosso canal oficial de atendimento:{" "}
            <a href="tel:+5511933333011" className="font-semibold underline underline-offset-2">
              (11) 93333-3011
            </a>.
          </p>
        </div>
      </section>
    </main>
  );
}
